import { Provider } from '@angular/core'

import { PricingPlanService } from '@ti/core/common/services'
import {
  AlertsServiceSchedulesProvider,
  CommonOptionsProvider,
  UnifiedSensorTriggersProvider,
} from '@ti/shared/alerts/providers'
import { AlertLabelsFormatter } from '@ti/shared/alerts/services'
import { CustomSensorsProvider } from '@ti/shared/fleet/services'

import { TspCustomSensorsAlertsProvider } from './custom-sensors-alerts.provider'
import { StubHighestPricingPlanService } from './pricing-plan.service'
import { TspAlertsServiceSchedulesProvider } from './service-schedules-alerts.provider'
import { TspUnifiedSensorAlertsProvider } from './unified-sensors-alerts.provider'

export const provideTspAlerts = (): Provider[] => {
  return [
    AlertLabelsFormatter,
    CommonOptionsProvider,
    { provide: CustomSensorsProvider, useClass: TspCustomSensorsAlertsProvider },
    { provide: PricingPlanService, useClass: StubHighestPricingPlanService },
    { provide: UnifiedSensorTriggersProvider, useClass: TspUnifiedSensorAlertsProvider },
    { provide: AlertsServiceSchedulesProvider, useClass: TspAlertsServiceSchedulesProvider },
  ]
}
